export default __webpack_public_path__ + "static/media/336.f48016d3.png";